"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants = {
    STATUS_PAGE_API: 'https://status.spoton.com/api/v2',
    COPY: 'We are currently experiencing technical difficulties with our platform and working to resolve them as soon as possible. We apologize for the inconvenience.',
};
exports.default = constants;
